import { Form, Input } from 'antd';
import CustomInputLabel from 'components/Label/CustomInputLabel';

const CustomTextareaInput = ({
	form,
	label,
	head,
	name,
	rules,
	value,
	size = 'default',
	count,
	autoComplete = 'off',
	placeholder = 'Write here',
	style,
	inputStyle,
	autoSize,
	...rest
}) => {
	return (
		<Form.Item name={name} label={label} rules={rules} style={style}>
			{/* {disabled ? (
				<CustomInputLabel head={head} label={form?.getFieldValue(name) ?? (value ? value : '')} sx={{ ...style }} />
			) : ( */}
			<Input.TextArea
				name={name}
				count={count}
				size={size}
				placeholder={placeholder}
				autoComplete={autoComplete}
				autoSize={autoSize ?? { minRows: 3, maxRows: 5 }}
				style={{ ...style, ...inputStyle }}
				{...rest}
			/>
			{/* )} */}
		</Form.Item>
	);
};

export default CustomTextareaInput;
